import React from 'react';
import Skeleton from '@/components/ui/Skeleton/Skeleton';
import cn from '@/utils/cn';

// AIDEV-NOTE: #f9f9f9 / #DBDBDB mirror the hardcoded values in questionCard.module.scss so the
// skeleton matches the real card 1:1. Neither hex exists as a shared token today; consolidating
// them across SCSS + Tailwind is a palette-refactor follow-up, out of scope for this file.
const CardSkeleton = () => (
  <div
    className={cn(
      'tw-my-6 tw-box-border tw-overflow-hidden tw-rounded tw-shadow',
      'tw-border tw-border-solid tw-border-[#DBDBDB]',
    )}
    data-testid="grading-skeleton-card"
  >
    <div className="tw-bg-[#f9f9f9] tw-px-5 tw-py-2.5">
      <Skeleton height="tw-h-3" width="tw-w-20" />
    </div>
    <div
      className={cn(
        'tw-flex tw-flex-col tw-gap-3 tw-px-6 tw-py-5',
        'tw-border-t tw-border-solid tw-border-[#DBDBDB]',
      )}
    >
      <Skeleton height="tw-h-5" width="tw-w-3/4" />
      <Skeleton height="tw-h-4" width="tw-w-1/2" />
      <div className="tw-flex tw-items-center tw-justify-between tw-pt-2">
        <Skeleton height="tw-h-4" width="tw-w-1/3" />
        <Skeleton height="tw-h-8" width="tw-w-24" />
      </div>
    </div>
  </div>
);

export default CardSkeleton;
